/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetJobPostingsAdminParams,
  GetJobPostingsParams,
  HTTPValidationError,
  JobPosting,
  JobPostingCreationArgs,
  JobPostingDeleteArgs,
  JobPostingUpdateArgs,
} from './platformapi.schemas';

import getJobPostingsAdminMutator from '../custom-axios-instance';
import countJobPostingsAdminMutator from '../custom-axios-instance';
import createJobPostingMutator from '../custom-axios-instance';
import deleteJobPostingMutator from '../custom-axios-instance';
import updateJobPostingMutator from '../custom-axios-instance';
import getJobPostingsMutator from '../custom-axios-instance';
import countJobPostingsMutator from '../custom-axios-instance';

/**
 * Retrieves all job openings
 * @summary Get Job Postings Admin
 */
export const getJobPostingsAdmin = (params: GetJobPostingsAdminParams, signal?: AbortSignal) => {
  return getJobPostingsAdminMutator<JobPosting[]>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/job-postings/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetJobPostingsAdminQueryKey = (params?: GetJobPostingsAdminParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/job-postings/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetJobPostingsAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobPostingsAdmin>>,
  TError = void | HTTPValidationError,
>(
  params: GetJobPostingsAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getJobPostingsAdmin>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobPostingsAdminQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobPostingsAdmin>>> = ({ signal }) =>
    getJobPostingsAdmin(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobPostingsAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetJobPostingsAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobPostingsAdmin>>
>;
export type GetJobPostingsAdminQueryError = void | HTTPValidationError;

export function useGetJobPostingsAdmin<
  TData = Awaited<ReturnType<typeof getJobPostingsAdmin>>,
  TError = void | HTTPValidationError,
>(
  params: GetJobPostingsAdminParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getJobPostingsAdmin>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobPostingsAdmin>>,
          TError,
          Awaited<ReturnType<typeof getJobPostingsAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetJobPostingsAdmin<
  TData = Awaited<ReturnType<typeof getJobPostingsAdmin>>,
  TError = void | HTTPValidationError,
>(
  params: GetJobPostingsAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getJobPostingsAdmin>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobPostingsAdmin>>,
          TError,
          Awaited<ReturnType<typeof getJobPostingsAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetJobPostingsAdmin<
  TData = Awaited<ReturnType<typeof getJobPostingsAdmin>>,
  TError = void | HTTPValidationError,
>(
  params: GetJobPostingsAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getJobPostingsAdmin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Job Postings Admin
 */

export function useGetJobPostingsAdmin<
  TData = Awaited<ReturnType<typeof getJobPostingsAdmin>>,
  TError = void | HTTPValidationError,
>(
  params: GetJobPostingsAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getJobPostingsAdmin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetJobPostingsAdminQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Counts all job openings
 * @summary Count Job Postings Admin
 */
export const countJobPostingsAdmin = (signal?: AbortSignal) => {
  return countJobPostingsAdminMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/job-postings/count`,
    method: 'GET',
    signal,
  });
};

export const getCountJobPostingsAdminQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/admin/job-postings/count`] as const;
};

export const getCountJobPostingsAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof countJobPostingsAdmin>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof countJobPostingsAdmin>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCountJobPostingsAdminQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof countJobPostingsAdmin>>> = ({ signal }) =>
    countJobPostingsAdmin(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof countJobPostingsAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountJobPostingsAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof countJobPostingsAdmin>>
>;
export type CountJobPostingsAdminQueryError = void | HTTPValidationError;

export function useCountJobPostingsAdmin<
  TData = Awaited<ReturnType<typeof countJobPostingsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countJobPostingsAdmin>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countJobPostingsAdmin>>,
          TError,
          Awaited<ReturnType<typeof countJobPostingsAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountJobPostingsAdmin<
  TData = Awaited<ReturnType<typeof countJobPostingsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countJobPostingsAdmin>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countJobPostingsAdmin>>,
          TError,
          Awaited<ReturnType<typeof countJobPostingsAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountJobPostingsAdmin<
  TData = Awaited<ReturnType<typeof countJobPostingsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countJobPostingsAdmin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Count Job Postings Admin
 */

export function useCountJobPostingsAdmin<
  TData = Awaited<ReturnType<typeof countJobPostingsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countJobPostingsAdmin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCountJobPostingsAdminQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new job posting
 * @summary Create Job Posting
 */
export const createJobPosting = (
  jobPostingCreationArgs: JobPostingCreationArgs,
  signal?: AbortSignal,
) => {
  return createJobPostingMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/job-postings/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: jobPostingCreationArgs,
    signal,
  });
};

export const getCreateJobPostingMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createJobPosting>>,
    TError,
    { data: JobPostingCreationArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createJobPosting>>,
  TError,
  { data: JobPostingCreationArgs },
  TContext
> => {
  const mutationKey = ['createJobPosting'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createJobPosting>>,
    { data: JobPostingCreationArgs }
  > = (props) => {
    const { data } = props ?? {};

    return createJobPosting(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateJobPostingMutationResult = NonNullable<
  Awaited<ReturnType<typeof createJobPosting>>
>;
export type CreateJobPostingMutationBody = JobPostingCreationArgs;
export type CreateJobPostingMutationError = void | HTTPValidationError;

/**
 * @summary Create Job Posting
 */
export const useCreateJobPosting = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createJobPosting>>,
      TError,
      { data: JobPostingCreationArgs },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createJobPosting>>,
  TError,
  { data: JobPostingCreationArgs },
  TContext
> => {
  const mutationOptions = getCreateJobPostingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a job posting
 * @summary Delete Job Posting
 */
export const deleteJobPosting = (
  jobPostingDeleteArgs: JobPostingDeleteArgs,
  signal?: AbortSignal,
) => {
  return deleteJobPostingMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/job-postings/delete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: jobPostingDeleteArgs,
    signal,
  });
};

export const getDeleteJobPostingMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJobPosting>>,
    TError,
    { data: JobPostingDeleteArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteJobPosting>>,
  TError,
  { data: JobPostingDeleteArgs },
  TContext
> => {
  const mutationKey = ['deleteJobPosting'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteJobPosting>>,
    { data: JobPostingDeleteArgs }
  > = (props) => {
    const { data } = props ?? {};

    return deleteJobPosting(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteJobPostingMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteJobPosting>>
>;
export type DeleteJobPostingMutationBody = JobPostingDeleteArgs;
export type DeleteJobPostingMutationError = void | HTTPValidationError;

/**
 * @summary Delete Job Posting
 */
export const useDeleteJobPosting = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteJobPosting>>,
      TError,
      { data: JobPostingDeleteArgs },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteJobPosting>>,
  TError,
  { data: JobPostingDeleteArgs },
  TContext
> => {
  const mutationOptions = getDeleteJobPostingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates an existing job posting
 * @summary Update Job Posting
 */
export const updateJobPosting = (
  jobPostingUpdateArgs: JobPostingUpdateArgs,
  signal?: AbortSignal,
) => {
  return updateJobPostingMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/job-postings/update`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: jobPostingUpdateArgs,
    signal,
  });
};

export const getUpdateJobPostingMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateJobPosting>>,
    TError,
    { data: JobPostingUpdateArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateJobPosting>>,
  TError,
  { data: JobPostingUpdateArgs },
  TContext
> => {
  const mutationKey = ['updateJobPosting'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateJobPosting>>,
    { data: JobPostingUpdateArgs }
  > = (props) => {
    const { data } = props ?? {};

    return updateJobPosting(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateJobPostingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateJobPosting>>
>;
export type UpdateJobPostingMutationBody = JobPostingUpdateArgs;
export type UpdateJobPostingMutationError = void | HTTPValidationError;

/**
 * @summary Update Job Posting
 */
export const useUpdateJobPosting = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateJobPosting>>,
      TError,
      { data: JobPostingUpdateArgs },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateJobPosting>>,
  TError,
  { data: JobPostingUpdateArgs },
  TContext
> => {
  const mutationOptions = getUpdateJobPostingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves currently available job postings
 * @summary Get Job Postings
 */
export const getJobPostings = (params: GetJobPostingsParams, signal?: AbortSignal) => {
  return getJobPostingsMutator<JobPosting[]>({
    url: `${import.meta.env['VITE_API_HOST']}/job-postings/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetJobPostingsQueryKey = (params?: GetJobPostingsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/job-postings/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetJobPostingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobPostings>>,
  TError = void | HTTPValidationError,
>(
  params: GetJobPostingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobPostings>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobPostingsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobPostings>>> = ({ signal }) =>
    getJobPostings(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobPostings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetJobPostingsQueryResult = NonNullable<Awaited<ReturnType<typeof getJobPostings>>>;
export type GetJobPostingsQueryError = void | HTTPValidationError;

export function useGetJobPostings<
  TData = Awaited<ReturnType<typeof getJobPostings>>,
  TError = void | HTTPValidationError,
>(
  params: GetJobPostingsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobPostings>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobPostings>>,
          TError,
          Awaited<ReturnType<typeof getJobPostings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetJobPostings<
  TData = Awaited<ReturnType<typeof getJobPostings>>,
  TError = void | HTTPValidationError,
>(
  params: GetJobPostingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobPostings>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobPostings>>,
          TError,
          Awaited<ReturnType<typeof getJobPostings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetJobPostings<
  TData = Awaited<ReturnType<typeof getJobPostings>>,
  TError = void | HTTPValidationError,
>(
  params: GetJobPostingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobPostings>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Job Postings
 */

export function useGetJobPostings<
  TData = Awaited<ReturnType<typeof getJobPostings>>,
  TError = void | HTTPValidationError,
>(
  params: GetJobPostingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobPostings>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetJobPostingsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves currently available job postings
 * @summary Count Job Postings
 */
export const countJobPostings = (signal?: AbortSignal) => {
  return countJobPostingsMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/job-postings/count`,
    method: 'GET',
    signal,
  });
};

export const getCountJobPostingsQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/job-postings/count`] as const;
};

export const getCountJobPostingsQueryOptions = <
  TData = Awaited<ReturnType<typeof countJobPostings>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countJobPostings>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCountJobPostingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof countJobPostings>>> = ({ signal }) =>
    countJobPostings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof countJobPostings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountJobPostingsQueryResult = NonNullable<Awaited<ReturnType<typeof countJobPostings>>>;
export type CountJobPostingsQueryError = void | HTTPValidationError;

export function useCountJobPostings<
  TData = Awaited<ReturnType<typeof countJobPostings>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof countJobPostings>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countJobPostings>>,
          TError,
          Awaited<ReturnType<typeof countJobPostings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountJobPostings<
  TData = Awaited<ReturnType<typeof countJobPostings>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countJobPostings>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countJobPostings>>,
          TError,
          Awaited<ReturnType<typeof countJobPostings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountJobPostings<
  TData = Awaited<ReturnType<typeof countJobPostings>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countJobPostings>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Count Job Postings
 */

export function useCountJobPostings<
  TData = Awaited<ReturnType<typeof countJobPostings>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countJobPostings>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCountJobPostingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
